import cx from 'classnames';
import type { Content } from '@plone/types';
import config from '@plone/volto/registry';

import { RichText } from '@redturtle/iovisit-theme/components/Views';

import { Booking, hasBooking } from '@redturtle/iovisit-theme/components/Views';
import type { EmbedTrekksoftData } from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/schema';

interface EmbedTrekksoftBodyData {
  content: Content;
  data: EmbedTrekksoftData;
}

const Body = ({ content, data }: EmbedTrekksoftBodyData) => {
  const Image = config.getComponent({ name: 'Image' }).component;

  const {
    description,
    title,
    full_width,
    bg_color,
    show_bg_image,
    bg_image,
    cta_box_color,
    cta_description,
  } = data;

  const descriptionText = RichText({
    content: description,
  });

  return (
    <div
      className={cx(`embed-trekksoft-block-wrapper`, {
        'full-width': full_width,
        'no-description': !descriptionText && title,
        [`bg-${bg_color}`]: !show_bg_image && bg_color,
        'bg-image': show_bg_image && bg_image,
      })}
    >
      {show_bg_image && bg_image && (
        <figure className="img-wrapper">
          <Image
            item={bg_image}
            sizes="100vw"
            loading="lazy"
            responsive={true}
            alt=""
            aria-hidden="true"
            role="presentation"
            key={data.bg_image?.['@id']}
          />
        </figure>
      )}
      <div
        className={cx('block-content', {
          'ui container': full_width,
        })}
      >
        <div className={cx('block-header')}>
          {title && (
            <div className="block-title">
              <h2>{title}</h2>
            </div>
          )}
          {description && (
            <div className="block-description">{descriptionText}</div>
          )}
        </div>

        <div className={cx(`booking-button cta-${cta_box_color}`)}>
          {cta_description && (
            <div className="cta-description">{cta_description}</div>
          )}
          {hasBooking(content) && <Booking content={content} />}
        </div>
      </div>
    </div>
  );
};

export default Body;
